angular.module("app").constant("popupsShowOnPage",
    ['home', 'sport', 'esports', 'poker', 'virtualsports', 'games', 'casino', 'livedealer', 'fantasy', 'tv-games', 'blast', 'pmu', 'promos', 'wonderwheel', 'tournaments']);
